import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { CITY, CITY_ALL, CITY_CREATE, CITY_LIST, GLOBAL_STATE } from '../constants/actionTypes'

const citysSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const citySelector = createSelector(citysSelector, data => data[CITY])

export const cityListSelector = createSelector(citysSelector, data => data[CITY_LIST])

export const cityAllSelector = createSelector(citysSelector, data => data[CITY_ALL])

export const cityCreateSelector = createSelector(citysSelector, data => data[CITY_CREATE])
